<template>
  <v-carousel :show-arrows="false" cycle>
    <v-carousel-item
      reverse-transition="fade-transition"
      src="../../../assets/images/slider/1.jpg"
      transition="fade-transition"
    >
    </v-carousel-item>
    <v-carousel-item
      src="../../../assets/images/slider/3.jpg"
      reverse-transition="fade-transition"
      transition="fade-transition"
    >
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  name: "Carousel",
};
</script>

<style scoped></style>
